export const KIND_ZH = {
    bus_route: '公車',
    bus_stop: '公車站',
    rail_station: '軌道站',
    rail_route: '軌道線',
    road: '路名',
    parking: '停車',
    poi: '店家'
};

export async function searchGisPlaces(query, opts = {}) {
    const q = String(query || '').trim();
    if (!q) return { hits: [], layers: {} };
    const params = new URLSearchParams({ q, limit: String(opts.limit || 24) });
    if (opts.kinds) params.set('kinds', Array.isArray(opts.kinds) ? opts.kinds.join(',') : opts.kinds);
    if (opts.motorcycleOnly) params.set('moto', '1');
    if (opts.hourlyOnly) params.set('hourly', '1');
    if (opts.vehicles) {
        params.set('veh', Array.isArray(opts.vehicles) ? opts.vehicles.join(',') : String(opts.vehicles));
    }
    if (opts.fees) {
        params.set('fee', Array.isArray(opts.fees) ? opts.fees.join(',') : String(opts.fees));
    }
    if (opts.city) params.set('city', String(opts.city));
    if (opts.district) params.set('district', String(opts.district));
    const res = await fetch(`/api/live/search?${params}`, { credentials: 'include' });
    if (!res.ok) return { hits: [], layers: {} };
    return res.json();
}
